var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bg-secondary-9 p-2 extra-info-container" }, [
    _c(
      "div",
      { staticClass: "bg-white p-3" },
      [
        _c("section-title", {
          staticClass: "my-2",
          attrs: {
            icon: "fas fa-bell-exclamation",
            title: _vm.title,
            "title-class": "extra-info-container__section-title__info"
          }
        }),
        _c("validation-observer", { ref: "statusExtraInfo" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col-12 col-md-7 pl-md-5 mb-2" }, [
              _vm.isApprovalAplication
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-7" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-input", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El número de planteamiento es requerido.",
                                        error: errors[0],
                                        label: "Número de Planteamiento:",
                                        type: "text"
                                      },
                                      model: {
                                        value: _vm.approach.approachNumber,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.approach,
                                            "approachNumber",
                                            $$v
                                          )
                                        },
                                        expression: "approach.approachNumber"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3790927516
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12 col-md-5 mt-1 mt-md-0" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-date-picker", {
                                      attrs: {
                                        "custom-error-msg":
                                          "La fecha de planteamiento a OGP es requerido.",
                                        error: errors[0],
                                        label: "Fecha de Planteamiento:",
                                        placeholder: "DD/MM/YYYY"
                                      },
                                      model: {
                                        value: _vm.approach.approachDate,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.approach,
                                            "approachDate",
                                            $$v
                                          )
                                        },
                                        expression: "approach.approachDate"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2727639897
                          )
                        })
                      ],
                      1
                    )
                  ])
                : _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("validation-provider", {
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El registro de contrato es requerido.",
                                      error: errors[0],
                                      label: "Registro de Contrato:",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.contractRegistration,
                                      callback: function($$v) {
                                        _vm.contractRegistration = $$v
                                      },
                                      expression: "contractRegistration"
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  ])
            ]),
            _c("div", { staticClass: "col-md-12 pl-md-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-end align-items-center pl-md-5"
                },
                [
                  _c(
                    "action-button",
                    {
                      attrs: {
                        id: "modal-btn-cancelar",
                        i: "fas fa-times-circle",
                        variant: "outline-danger mr-2"
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "action-button",
                    {
                      attrs: { i: "fa fa-save", variant: "success px-3" },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" Guardar ")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }